<template>
		<!-- Main content -->
		<div class="content-wrapper">

			<!-- Page header -->
			<app-breadcrumb/>
			<!-- /page header -->

			<!-- Content area -->
			<div class="content">

			<!-- Simple panel -->
			<div class="panel panel-flat border-top-lg border-top-success">

				<div class="panel-body">
					
					<!-- begin::row -->
					<div class="row">
						<div class="col-md-3">
							<!-- begin::Panel Total -->
							<div class="panel panel-body bg-blue-400 has-bg-image">
								<div class="media no-margin">
									<div class="media-body">
										<h3 class="no-margin">Total Movies</h3>
										<h4 class="text-uppercase">{{ total_movies }}</h4>
									</div>

									<div class="media-right media-middle">
										<i class="icon-movie icon-3x opacity-75"></i>
									</div>
								</div>
							</div>
							<!-- end::Panel Total -->
						</div>

						<div class="col-md-3">
							<!-- begin::Panel Total -->
							<div class="panel panel-body bg-teal-400 has-bg-image">
								<div class="media no-margin">
									<div class="media-body">
										<h3 class="no-margin">Total Series</h3>
										<h4 class="text-uppercase">{{ total_series }}</h4>
									</div>

									<div class="media-right media-middle">
										<i class="icon-tv icon-3x opacity-75"></i>
									</div>
								</div>
							</div>
							<!-- end::Panel Total -->
						</div>
						<div class="col-md-3">
							<!-- begin::Panel Total -->
							<div class="panel panel-body bg-green-400 has-bg-image">
								<div class="media no-margin">
									<div class="media-body">
										<h3 class="no-margin">Total Servers</h3>
										<h4 class="text-uppercase">{{ total_servers }}</h4>
									</div>

									<div class="media-right media-middle">
										<i class="icon-server icon-3x opacity-75"></i>
									</div>
								</div>
							</div>
							<!-- end::Panel Total -->
						</div>

						<div class="col-md-3">
							<!-- begin::Panel Total -->
							<div class="panel panel-body bg-pink-400 has-bg-image">
								<div class="media no-margin">
									<div class="media-body">
										<h3 class="no-margin">Total Users</h3>
										<h4 class="text-uppercase">{{ total_users }}</h4>
									</div>

									<div class="media-right media-middle">
										<i class="icon-users2 icon-3x opacity-75"></i>
									</div>
								</div>
							</div>
							<!-- end::Panel Total -->
						</div>

					</div>
					<!-- begin::row -->

				</div>

			</div>
			<!-- /simple panel -->

				<!-- Footer -->
				<app-footer/>
				<!-- /footer -->

			</div>
			<!-- /content area -->
		</div>
		<!-- /main content -->
</template>

<script>
import axios from 'axios'
import lodash from 'lodash'
const token = localStorage.getItem('token')
export default {
  name: 'Dashboard',
  data () {
    return {

    }
  },
  computed: {
    total_movies () {
      return this.$store.getters.total_movies
    },
    total_series () {
      return this.$store.getters.total_series
    },
    total_servers () {
      return this.$store.getters.total_servers
    },
    total_users () {
      return this.$store.getters.total_users
    }
    //
  },
  mounted() {
    return this.$store.dispatch('loadDataDashboard')
  },
  //
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/Dashboard.vue